import { createContext, useContext, ReactNode } from "react";

import { PresenceUser } from "./presenceTypes";
import usePresence from "./usePresence";

type PresenceContextType = {
  users: PresenceUser[];
};

const PresenceContext = createContext<PresenceContextType | null>(null);

const NullPresenceProvider = ({ children }: { children: ReactNode }) => (
  <PresenceContext.Provider value={{ users: [] }}>
    {children}
  </PresenceContext.Provider>
);

export const PresenceProvider = ({
  slug,
  children,
  presenceDetectionEnabled,
}: {
  slug: string | null;
  children: ReactNode;
  presenceDetectionEnabled: boolean;
}) => {
  if (!presenceDetectionEnabled) {
    return <NullPresenceProvider>{children}</NullPresenceProvider>;
  }
  return <PresenceProviderCore slug={slug}>{children}</PresenceProviderCore>;
};

const PresenceProviderCore = ({
  slug,
  children,
}: {
  slug: string | null;
  children: ReactNode;
}) => {
  const presence = usePresence(slug);
  return (
    <PresenceContext.Provider value={presence}>
      {children}
    </PresenceContext.Provider>
  );
};

export const usePresenceContext = () => {
  const ctx = useContext(PresenceContext);
  if (!ctx)
    throw new Error(
      "usePresenceContext must be used within a PresenceProvider"
    );
  return ctx;
};
